<template>
  <el-row>
    <el-form :model="spreadGoodsForm"
             ref="spreadGoodsRef"
             :rules="rules"
             addAction="/businessIntranet/createBusinessSpreadOrder.action"
             editAction="/businessIntranet/createBusinessSpreadOrder.action"
             label-width="150px"
             style="width:40%"
             v-form>
            <el-form-item label="推广费用：" prop="totalMoney">
                <el-input type="number" v-model="spreadGoodsForm.totalMoney"  placeholder="请输入推广费用(支持2位小数)"></el-input>
            </el-form-item>

        <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import EmployeeSelect from '@/components/EmployeeSelect'

export default {
  name: 'spreadGoods',
  extends: BasicPager,
  components: { EmployeeSelect },
  data: function () {
    let checkDecima = (rule, value, callback) => {
      if (value < 0) {
        return callback(new Error('请填写大于0的数值'))
      }

      let match = (value + '').match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留两位哦！'))
      }
      callback()
    }
    return {
      rules: {
        totalMoney: [{
          required: true,
          message: '请输入推广金额'
        },
        { validator: checkDecima, trigger: 'blur' }
        ]
      },
      spreadGoodsForm: {
        businessId: null,
        newAddGoodsId: null,
        totalMoney: null

      }
    }
  },
  created () {
    this.spreadGoodsForm.businessId = this.$route.query.businessId
    this.spreadGoodsForm.newAddGoodsId = this.$route.query.newAddGoodsId
  },
  methods: {
    clear: function () {
      this.spreadGoodsForm.maintenanceEmployeeSnapId = null
      this.spreadGoodsForm.maintenanceName = null
      this.spreadGoodsForm.nextVisitTime = null
    },
    onEmployeeSelectedQuery: function (item) {
      this.spreadGoodsForm.maintenanceEmployeeSnapId = item.snapshotId
      this.spreadGoodsForm.maintenanceName = item.text
    },
    onFilterParams: function (params) {
      params.totalMoney = parseInt(params.totalMoney * 100)
    },
    onSelectInfo: function (dataInfo) {

    }
  }

}
</script>

<style scoped>

</style>
